<template>
  <v-sheet height="500">
    <v-toolbar
      flat
      color="white"
    >
      <v-btn
        icon
        @click="$refs.calendar.prev()"
      >
        <v-icon dark>
          keyboard_arrow_left
        </v-icon>
      </v-btn>

      <v-btn
        icon
        @click="$refs.calendar.next()"
      >
        <v-icon dark>
          keyboard_arrow_right
        </v-icon>
      </v-btn>

      <v-toolbar-title>{{ currentMonth }}</v-toolbar-title>
    </v-toolbar>

    <v-calendar
      ref="calendar"
      v-model="start"
      :type="type"
      color="primary"
    />
  </v-sheet>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      start: moment().format('YYYY-MM-DD'),
      type: 'month'
    }
  },
  computed: {
    currentMonth () {
      return moment(this.start).format('MMMM')
    }
  }
}
</script>

<style>

</style>
